import { Stack, Typography } from '@mui/material';
import type {
  BackupPolicyType,
  BackupSchedule,
  NativeStandardConfigVaultProtectionModeEnum,
  ScheduleMode,
} from '@repo/api-gw-sdk';

import { ButtonWithIcon } from '@/components/buttons/buttonWithIcon';

import { BackupPolicySchedule } from './BackupPolicySchedule';

export const BackupPolicyScheduleList = ({
  policyType,
  schedules,
  onUpdate: updateSchedule,
  deleteAllowed,
  onDuplicate: duplicateSchedule,
  onDelete: removeSchedule,
  mode,
  onAdd,
  addButtonText,
  title,
  subtitle,
  vaultProtectionMode,
}: {
  policyType: BackupPolicyType;
  schedules: BackupSchedule[];
  onUpdate: (schedule: BackupSchedule) => void;
  deleteAllowed: boolean;
  onDuplicate: (schedule: BackupSchedule) => void;
  onDelete: (schedule: BackupSchedule) => void;
  mode: ScheduleMode;
  onAdd: () => void;
  addButtonText: string;
  title?: string;
  subtitle?: string;
  vaultProtectionMode?: NativeStandardConfigVaultProtectionModeEnum;
}) => {
  return (
    <Stack gap='24px'>
      {(title || subtitle) && (
        <Stack gap='8px'>
          {title && <Typography variant='subtitle1'>{title}</Typography>}
          {subtitle && (
            <Typography variant='body1' width='540px'>
              {subtitle}
            </Typography>
          )}
        </Stack>
      )}
      {!!schedules.length && (
        <Stack gap='12px'>
          {schedules.map((schedule) => (
            <BackupPolicySchedule
              deleteAllowed={deleteAllowed}
              schedule={schedule}
              key={schedule.id}
              onUpdate={updateSchedule}
              onDuplicate={duplicateSchedule}
              onDelete={removeSchedule}
              mode={mode}
              policyType={policyType}
              vaultProtectionMode={vaultProtectionMode}
            />
          ))}
        </Stack>
      )}
      <ButtonWithIcon
        data-testid='create-backup-policy-add-backup-schedule-btn'
        icon='material-symbols-add-rounded'
        text={addButtonText}
        onClick={onAdd}
      />
    </Stack>
  );
};
